import { PurchaseStatus } from '../enums';

export interface Purchase {
  id: string;
  userId: string;
  productId: string;
  status: PurchaseStatus;
  stripePaymentId: string | null;
  createdAt: Date;
  updatedAt: Date;
}
